import {Stack} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import {
    InlineInput,
    InlineLabelledField,
    localizedValue,
    patchLocalized,
    QuestionEditorProps
} from "./questionEditor.types";

function TextQuestionEditor(props: QuestionEditorProps) {
    const {t} = useTranslation();
    const {question, language, disabled} = props;

    return (
        <Stack gap={1.5}>
            <InlineLabelledField label={t('Placeholder')}>
                <InlineInput
                    value={localizedValue(question.placeholder, language)}
                    onChange={(value) => patchLocalized(props, 'placeholder', value)}
                    disabled={disabled}
                />
            </InlineLabelledField>
        </Stack>
    );
}

export default TextQuestionEditor;
